import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Spinner } from "react-bootstrap";

//
import { resendVarifyEmail } from "../../../redux/features/user/actions";

function EmailVerify({ user }) {
  const [loading, setLoading] = useState(false);

  /**
   * Resend Verify Email
   */

  const resend_varify_email = async () => {
    // start loading
    setLoading(true);

    // request
    await resendVarifyEmail();

    // stop loading
    setLoading(false);
  };
  return (
    <div className="email-verify">
      <p>Verify Email</p>
      <p className={user.email_verified_at ? "mb-0" : "text-danger"}>
        {user.email_verified_at
          ? "Your email is verifed"
          : "Your email is not verifed"}
      </p>
      {!user.email_verified_at && (
        <p
          className="fw-extra-bolder pointer d-flex"
          onClick={() => resend_varify_email()}
        >
          Send email
          {loading && (
            <Spinner
              animation="border"
              variant="dark"
              size="sm"
              className="ms-2"
            />
          )}
        </p>
      )}
    </div>
  );
}

EmailVerify.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.userReducer.user,
});

export default connect(mapStateToProps)(EmailVerify);
